/**
 * regressionRuns.service.ts — Layer 3: Regression Test (Serenity/Cucumber) Domain
 */

import { getRequest } from './http.service';
import {
  URL_REGRESSION_RUNS_LIST,
  URL_REGRESSION_RUN_LATEST,
  URL_REGRESSION_RUN_HISTORY_BAR,
  URL_REGRESSION_RUN_BY_ID,
} from './url.service';

/** Get a page of past regression runs (summary only, no per-scenario detail) */
export const fetchRegressionRuns = (page: number, limit: number) =>
  getRequest(URL_REGRESSION_RUNS_LIST(page, limit));

/** Get the latest completed regression run, with full per-scenario detail */
export const fetchLatestRegressionRun = () =>
  getRequest(URL_REGRESSION_RUN_LATEST);

/** Get pass/fail summaries for the last n runs, oldest first (for the run-history bar) */
export const fetchRegressionRunHistoryBar = (n: number = 90) =>
  getRequest(URL_REGRESSION_RUN_HISTORY_BAR(n));

/** Get the full detail of a single regression run */
export const fetchRegressionRunById = (id: string) =>
  getRequest(URL_REGRESSION_RUN_BY_ID(id));
